import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../hooks/useToast';
import { Button } from './ui/Button';

export function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const initials = user?.email ? user.email[0].toUpperCase() : '?';

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login', { replace: true });
    } catch {
      showToast('Failed to logout', 'error');
    }
  };

  return (
    <header className="app-header">
      <span className="app-header__logo">
        <span className="wordmark">Histo<span className="wordmark__r">R</span>yjki</span>
      </span>
      <span className="app-header__spacer" />
      <div className="app-header__right">
        <div className="app-header__avatar" title={user?.email}>
          {initials}
        </div>
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </header>
  );
}
